export enum PaymentTypes {
    Direct = "direct",
    OffSession = "off-session",
    CreditCardGuarantee = "credit-card-guarantee",
}
